// 接龙vip
module.exports= {
	/* 小程序的名称 */
	appletsName: '接龙加加 - 免费微信接龙报名小程序平台',
	AppID: 'wx1e899bddb256a5ca',
	appletBannerImage:'',
	appletLogoImage:'https://ossfastmake.mustke.com//12jielong/lsyJL/jljiajia.svg'
}


// 报名管家
// module.exports= {
// 	/* 小程序的名称 */
// 	appletsName: '报名管家 - 免费微信接龙报名小程序平台',
// 	AppID: 'wx7d8daf6d777947a2',
// 	appletBannerImage:'',
// 	appletLogoImage:'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bmgjlogo.png'
// }

// 报名管家vip
// module.exports= {
// 	/* 小程序的名称 */
// 	appletsName: '报名管家vip - 免费微信接龙报名小程序平台',
// 	AppID: 'wx33faec64a79cd165',
// 	appletBannerImage:'',
// 	appletLogoImage:'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bmgjlogo.png'
// }